import React, { useContext, useRef, useState } from "react";
import { GrigoraEditorContext } from "../context";
import slugify from "slugify";
import "./settings-general.scss";
import { INPUT_LIMITS } from "../../input-limits";
import { WhiteLabelContext } from "../../whitelabel";
function SettingsGeneral({ open, setOpen }) {
  const { project, changeProjectData } = useContext(GrigoraEditorContext);
  const [url, setUrl] = useState(project.slug);
  const [title, setTitle] = useState(project.name);

  const titleRef = useRef();
  const urlRef = useRef();

  const { __whitelabel_website_publishing_domain__ } =
    useContext(WhiteLabelContext) ?? {};

  const titleCheck = () => {
    let regex = /^[a-zA-Z0-9 ]+$/;
    if (title.length >= 5 && regex.test(title)) {
      titleRef.current.innerText = "";
      return true;
    } else {
      titleRef.current.innerText =
        "Project name should be greater than 5 characters and can only contain numbers, alphabet and space.";
      titleRef.current.style.color = "red";
      titleRef.current.style.fontSize = "12px";

      return false;
    }
  };
  const urlCheck = () => {
    if (url !== "" && url.length >= 5) {
      urlRef.current.innerText = "";
      return true;
    } else {
      urlRef.current.innerText =
        "Project Subdomain can't be empty and should be longer than 4 characters.";
      urlRef.current.style.color = "red";
      urlRef.current.style.fontSize = "12px";
      return false;
    }
  };

  const resetRef = () => {
    urlRef.current.innerText = "";
    titleRef.current.innerText = "";
  };

  const updateDetails = (e) => {
    e.preventDefault();
    resetRef();
    if (titleCheck() && urlCheck()) {
      changeProjectData(title, url)
        .then(() => {
          setOpen(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <div className="general-settings p-5 text-grigora-base">
      <div className="mb-3">
        <label>Your Website Name</label>
        <br />
        <input
          minLength={INPUT_LIMITS["website-name"].minlength}
          maxLength={INPUT_LIMITS["website-name"].maxlength}
          type="text"
          value={title}
          onChange={(e) => {
            if (e.target.value.length > 63) {
              return;
            }
            setTitle(e.target.value);
          }}
          className="input-field"
          placeholder="Your website name..."
        />
        <label ref={titleRef}></label>
      </div>
      <div className="mb-5">
        <label>Your Website URL</label>
        <br />
        <input
          type="text"
          minLength={INPUT_LIMITS["website-url"].minlength}
          maxLength={INPUT_LIMITS["website-url"].maxlength}
          value={project.domain ? project.domain : url}
          onChange={(e) => {
            setUrl(
              slugify(e.target.value, {
                trim: false,
                strict: true,
                lower: true,
              }),
            );
          }}
          disabled={project.domain ? true : false}
          className="input-field"
          placeholder="Your site url..."
        />
        <label ref={urlRef}></label>
        {project?.domain && (
          <p className="text-red-600 text-xs mt-3">
            You can&apos;t change slug when custom domain is set.
          </p>
        )}
        <div className="text-gray-500 mt-3 truncate">
          {project?.domain ? (
            <span>{project.domain}</span>
          ) : url ? (
            <span>{`${url}.${__whitelabel_website_publishing_domain__()}`}</span>
          ) : null}
        </div>
      </div>

      <div className="flex justify-end">
        <button onClick={updateDetails} className=" grigora-action-btn ">
          Update
        </button>
      </div>
    </div>
  );
}

export default SettingsGeneral;
